import React from "react";
import ApexChart from "react-apexcharts";

const ProfileRadialChart = (props) => {
  let { percentage, labels, main } = props;
  return (
    <div>
      <ApexChart
        options={{
          chart: {
            height: 200,
            type: "radialBar"
          },
          plotOptions: {
            radialBar: {
              hollow: {
                background: "#3C95E71A",
                position: "front",
                size: "45%",
              },
              dataLabels: {
                show: true,
                name: {
                  offsetY: 10,
                },
                value: {
                  fontSize: "15px",
                  offsetY: -20,
                  fontWeight: "bold",
                  color: "#3C95E7",
                  
                },
                total: {
                  label: "Percentile Rank",
                  fontSize: "9px",
                  fontWeight: "bold",
                  color: "#3C95E7",
                  show: true,
                  
                  formatter: function (w) {
                    return main;
                  },
                },
              },
              hover: {
                filter: {
                  type: "none",
                },
              },
            },
          },
          labels: labels,
         
          colors: ["#E87002", "#FFC530", "#FFE922"],
        }}
        series={percentage}
        type="radialBar"
        height={200}
      />
    </div>
  );
};

export default ProfileRadialChart;
